import * as React from 'react';

import PropTypes from 'prop-types';
import { trackEvent } from '../analytics/tracking';
import closeX from '../../assets/closeX.png';

import styles from './DisplayModal.module.css';

const DisplayLayer = ({children, trackLabel, closeFn}) => {

  React.useEffect(() => {
    // track if desired
    trackLabel && trackEvent(trackLabel);
  }, [trackLabel]);

  return (
    <div style={{position:'relative', zIndex:2, flexBasis:'100%'}}>
      <div className={styles.layerContent}>
        <img alt="" className={styles.closeIcon} src={closeX} height="18" onClick={closeFn} />
        <div className={styles.layerInner}>
          {children}
        </div>
      </div>  
    </div> 
  );
};

DisplayLayer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object,PropTypes.array]).isRequired
};

export default DisplayLayer;